import { Customer } from '../../interfaces/Customer';

export const validateAllFields = (customer: Customer, financialsValid: boolean[], employeesValid: boolean) => {
    const newErrors: { [key: string]: string } = {};

    // Validate NIP
    if (!customer.nip) {
        newErrors.nip = 'Wypełnij NIP.';
    } else if (!/^\d{10}$/.test(customer.nip)) {
        newErrors.nip = 'NIP musi zawierać dokładnie 10 cyfr.';
    }

    // Validate REGON
    if (!customer.regon) {
        newErrors.regon = 'Wypełnij REGON.';
    } else if (!/^\d{9}$/.test(customer.regon)) {
        newErrors.regon = 'REGON musi zawierać dokładnie 9 cyfr.';
    }

    // Validate PKD
    if (!customer.pkd) {
        newErrors.pkd = 'Wypełnij PKD.';
    }

    // Validate sex
    if (!customer.sex) {
        newErrors.sex = 'Wypełnij płeć.';
    } else if (!/^[mk]$/.test(customer.sex)) {
        newErrors.sex = 'Dozwolone wartości: m/k.';
    }

    // Validate PESEL
    if (!customer.pesel) {
        newErrors.pesel = 'Wypełnij PESEL.';
    } else if (!/^\d{11}$/.test(customer.pesel)) {
        newErrors.pesel = 'PESEL musi zawierać dokładnie 11 cyfr.';
    }

    // Validate email
    if (!customer.email) {
        newErrors.email = 'Wypełnij email.';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(customer.email)) {
        newErrors.email = 'Nieprawidłowy adres email.';
    }

    // Validate phoneNumber
    if (!customer.phoneNumber) {
        newErrors.phoneNumber = 'Wypełnij numer telefonu.';
    } else if (!/^[1-9]\d{8}$/.test(customer.phoneNumber)) {
        newErrors.phoneNumber = 'Numer telefonu powinien mieć 9 cyfr i nie zaczynać się od zera.';
    }

    // Validate zipCode (companyZipCode and zipCode)
    if (!customer.companyAddress?.zipCode) {
        newErrors.companyZipCode = 'Wypelnij kod pocztowy firmy'
    } else if (!/^\d{5}$/.test(customer.companyAddress.zipCode)) {
        newErrors.companyZipCode = 'Kod pocztowy powinien być w formacie XXXXX.';
    }

    if (!customer.address?.zipCode) {
        newErrors.zipCode = 'Wypelnij kod pocztowy'
    } else if (!/^\d{5}$/.test(customer.address.zipCode)) {
        newErrors.companyZipCode = 'Kod pocztowy powinien być w formacie XXXXX.';
    }


    // Validate accountNumber
    if (!customer.accountNumber) {
        newErrors.accountNumber = 'Wypelnij numer konta';
    } else if (!/^\d{26}$/.test(customer.accountNumber)) {
        newErrors.accountNumber = 'Numer konta powinien zawierać 26 znaków';
    }

    // Validate companyName
    if (!customer.companyName) {
        newErrors.companyName = 'Wypełnij nazwę firmy.';
    }

    // Validate companyOwnerName
    if (!customer.companyOwnerName) {
        newErrors.companyOwnerName = 'Wypełnij imię właściciela firmy.';
    }

    // Validate companyOwnerSurname
    if (!customer.companyOwnerSurname) {
        newErrors.companyOwnerSurname = 'Wypełnij nazwisko właściciela firmy.';
    }

    // Validate companyAddress fields
    if (!customer.companyAddress.streetName) {
        newErrors.companyStreetName = 'Wypełnij ulicę firmy.';
    }
    if (!customer.companyAddress.streetNumber) {
        newErrors.companyStreetNumber = 'Wypełnij numer budynku firmy.';
    }
    if (!customer.companyAddress.city) {
        newErrors.companyCity = 'Wypełnij miasto firmy.';
    }

    // Validate address fields
    if (!customer.address.streetName) {
        newErrors.streetName = 'Wypełnij ulicę.';
    }
    if (!customer.address.streetNumber) {
        newErrors.streetNumber = 'Wypełnij numer ulicy.';
    }
    if (!customer.address.city) {
        newErrors.city = 'Wypełnij miasto.';
    }

    if (!customer.address.district) {
        newErrors.district = 'Wypełnij powiat.';
    }

    if (!customer.name) {
        newErrors.name = 'Wypełnij Imię.';
    }

    if (!customer.surname) {
        newErrors.surname = 'Wypełnij Nazwisko.';
    }

    if (!customer.education) {
        newErrors.education = 'Wypełnij Wykształcenie.';
    }

    if (!customer.bankName) {
        newErrors.bankName = 'Wypełnij nazwę banku.';
    }

    if (!customer.address.district) {
        newErrors.district = 'Wypełnij powiat.';
    }

    if (!customer.address.municipality) {
        newErrors.municipality = 'Wypełnij gminę.';
    }

    // Validate voivodeship
    const validVoivodeships = [
        'dolnośląskie', 'kujawsko-pomorskie', 'lubelskie', 'lubuskie',
        'łódzkie', 'małopolskie', 'mazowieckie', 'opolskie', 'podkarpackie',
        'podlaskie', 'pomorskie', 'śląskie', 'świętokrzyskie', 'warmińsko-mazurskie',
        'wielkopolskie', 'zachodniopomorskie'
    ];
    if (!customer.address.voivodeship) {
        newErrors.voivodeship = 'Wypełnij województwo.';
    } else if (!validVoivodeships.includes(customer.address.voivodeship.toLowerCase())) {
        newErrors.voivodeship = 'Województwo musi być jednym z województw Polski.';
    }

    // Validate municipalityCode
    if (!customer.address.municipalityCode) {
        newErrors.municipalityCode = 'Wypełnij kod gminy.';
    } else if (!/^\d{6} \d{1}$/.test(customer.address.municipalityCode)) {
        newErrors.municipalityCode = 'Kod gminy musi składać się z 7 cyfr. Ostatniej oddzielonej spacją';
    }

    const allFinancialsValid = financialsValid.every(valid => valid);
    if (!allFinancialsValid) {
        newErrors.financials = 'Wypełnij poprawnie wszystkie pola finansowe.';
    }

    if (!employeesValid) {
        newErrors.employees = 'Wypełnij poprawnie wszystkich pracowników.';
    }
    return newErrors;
};